function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "disabled", "onChange", "style", "value", "type", "onKeyDown"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { Clear, Search } from '@procore/core-icons/dist';
import React from 'react';
import { Button } from '../Button/Button';
import { useLayoutEventListener } from '../_hooks/EventListener';
import { mergeRefs } from '../_utils/mergeRefs';
import { StyledIcon, StyledInput, StyledTypeahead } from './Typeahead.styles';
/**
 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-typeahead--demo)

 */
export var Typeahead = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    onChange_ = _ref.onChange,
    style = _ref.style,
    value = _ref.value,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'search' : _ref$type,
    onKeyDown_ = _ref.onKeyDown,
    props = _objectWithoutProperties(_ref, _excluded);
  var onChange = React.useCallback(function onChange(e) {
    onChange_ === null || onChange_ === void 0 ? void 0 : onChange_(e.target.value, e);
  }, [onChange_]);
  var innerRef = React.useRef(null);
  useLayoutEventListener({
    dependencies: [onChange_, onKeyDown_],
    event: 'keydown',
    handler: function onKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        // stop propagation once to clear input
        if (e.target.value) {
          e.stopPropagation();
        }
        onChange_ === null || onChange_ === void 0 ? void 0 : onChange_('', _objectSpread(_objectSpread({}, e), {}, {
          target: _objectSpread(_objectSpread({}, e.target), {}, {
            value: ''
          })
        }));
      }
      onKeyDown_ === null || onKeyDown_ === void 0 ? void 0 : onKeyDown_(e);
    },
    scope: innerRef
  });
  var onClickClear = React.useCallback(function onClickClear(e) {
    if (!disabled) {
      onChange_ === null || onChange_ === void 0 ? void 0 : onChange_('', _objectSpread(_objectSpread({}, e), {}, {
        target: _objectSpread(_objectSpread({}, e.target), {}, {
          value: ''
        })
      }));
    }
  }, [disabled, onChange_]);
  return /*#__PURE__*/React.createElement(StyledTypeahead, {
    className: className,
    style: style,
    "data-qa": props['data-qa']
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({}, props, {
    type: type,
    "data-qa": "core-typeahead-input",
    ref: mergeRefs(innerRef, ref),
    onChange: onChange,
    disabled: disabled,
    value: value
  })), /*#__PURE__*/React.createElement(StyledIcon, {
    disabled: disabled
  }, value ? /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Clear the input",
    "data-qa": "core-typeahead-clear-icon",
    size: "sm",
    variant: "tertiary",
    icon: /*#__PURE__*/React.createElement(Clear, null),
    disabled: disabled,
    onClick: onClickClear,
    tabIndex: -1 // TODO revisit this accessibility
  }) : /*#__PURE__*/React.createElement(Search, {
    "data-qa": "core-typeahead-search-icon",
    size: "sm"
  })));
});
//# sourceMappingURL=Typeahead.js.map